import React, { useEffect } from "react";
import { connect } from "react-redux";
import "./App.css";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import SignIn from "./App/Auth/components/SignIn";
import ResetPassword from "./App/Auth/components/ResetPassword";
import ResetPasswordForm from "./App/Auth/components/ResetPassword/ResetPasswordForm";
import AcceptInvitation from "./App/Auth/components/AcceptInvitation";
import { bindActionCreators } from "redux";
import { appActions } from "./redux/modules/app";
import PrivateRoute from "./App/Auth/PrivateRoute";
import { ROUTES } from "./Util/routes";
import BaseLayout from "./App/layouts/BaseLayout";
import Unauthorized from "./App/Auth/components/Unauthorized";
import AppContextProvider from "./context/AppContext";

Spin.setDefaultIndicator(<LoadingOutlined style={{ fontSize: 24 }} spin />);

function App() {
  useEffect(() => {
    const originalError = window.onerror;
    window.onerror = (message, source, lineno, colno, error) => {
      if (message.includes('ResizeObserver loop completed with undelivered notifications')) {
        return true;
      }
      if (originalError) {
        return originalError(message, source, lineno, colno, error);
      }
      return false;
    };

    return () => {
      window.onerror = originalError;
    };
  }, []);

  return (
    <AppContextProvider>
      <div className="App">
        <BrowserRouter>
          <Switch>
            <PrivateRoute exact path={ROUTES.ROOT} component={BaseLayout} />
            <PrivateRoute path={ROUTES.USERS} component={BaseLayout} />
            <PrivateRoute path={ROUTES.EXCEPTIONS} component={BaseLayout} />
            <PrivateRoute path={ROUTES.ROLES} component={BaseLayout} />
            <PrivateRoute path={ROUTES.DOCUMENTS} component={BaseLayout} />
            <PrivateRoute path={ROUTES.PROJECT_MANAGEMENT} component={BaseLayout} />
            <PrivateRoute path={ROUTES.SETTINGS} component={BaseLayout} />
            <PrivateRoute
              path="/project/:projectId"
              component={BaseLayout}
            />

            <Route path="/unauthorized" component={Unauthorized} />
            <Route path="/signin" component={SignIn} />
            <Route exact path="/reset-password" component={ResetPassword} />
            <Route path="/reset-password/form" component={ResetPasswordForm} />
            <Route path="/accept-invitation" component={AcceptInvitation} />

            {/* Fallback for unknown routes */}
            <Redirect to={ROUTES.ROOT} />
          </Switch>
        </BrowserRouter>
      </div>
    </AppContextProvider>
  );
}

const mapDispatchToProps = (dispatch) => ({
  reloadPage: bindActionCreators(appActions.reloadPage, dispatch),
});

export default connect(null, mapDispatchToProps)(App);
